import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../../api/client";
import "../../style/pages.css";
import "./NewsInner.css";

export default function NewsInner() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  useEffect(() => { api.getNews(id).then(setItem); }, [id]);
  if (!item) return <div className="empty-state">기록 복원 중...</div>;
  return (
    <article className="news-detail panel">
      <Link to="/" className="back-link">← 상황실로 복귀</Link>
      <div className="news-detail-meta"><span>{item.category}</span><time>{item.createdAt}</time></div>
      <h1>{item.title}</h1>
      <p className="news-lead">{item.summary}</p>
      <div className="transmission-line"><span>RECORDED BY</span><strong>{item.author}</strong><span>INTEGRITY</span><strong>94.2%</strong></div>
      <div className="news-body">{item.body}</div>
      <footer>본 기록은 GB-33-A 폐쇄망에 보존됩니다. 외부 전송을 금지합니다.</footer>
    </article>
  );
}
